/**
 * @desc: 项目打款 API
 * @author: zengtiansheng
 * @update: 2018/3/20
 */
export default {
  transferAccountsList: '/qtbCompanyCenter/wallet/transferAccounts/query/mobile', //搜索子账号列表
  createTransferAccounts: '/qtbCompanyCenter/wallet/transferAccounts/create/transferAccounts', //转账-创建订单
  payTransferAccounts: '/qtbCompanyCenter/wallet/transferAccounts/pay/transferAccounts', //转账-支付订单
  payOrderForId: '/qtbCompanyCenter/pc/payOrder/id', //根据订单id 跳转到支付宝支付
  cooperationSave: '/qtbCompanyCenter/cooperation/save' //存储合作内容 ，存储数量不限制 可以重复提交 判断数字长短等此接口不做限制,由客户端限制
}



// WEBPACK FOOTER //
// ./src/views/home/API.js